export default "__VITE_ASSET__BwQVKL1e__"